@if (platformMode.appsClosedForMe()) {
  <div class="alert alert-warning m-5" role="status">
    <i eIcon icon="lock" class="me-1"></i>
    <strong>{{ 'platform.mode.fullAccessOnly.title' | transloco }}</strong>
    <div>{{ 'platform.mode.fullAccessOnly.text' | transloco }}</div>
    <div>{{ 'platform.mode.contact' | transloco }}</div>
  </div>
} @else if (userQueries.hasNoAppsWithAccess$ | async) {
  <div
    class="alert alert-warning m-5"
    >
    <i eIcon icon="lock"></i>
    Geen applicaties, contacteer systeem beheerder
  </div>
} @else {
  <div class="d-flex justify-content-center mt-3">
    <div>
      <div class="d-flex justify-content-center"></div>
    </div>
  </div>
}

